import { render, staticRenderFns } from "./extrato-formularios-declaracoes.vue?vue&type=template&id=1a588da6&scoped=true"
import script from "./extrato-formularios-declaracoes.vue?vue&type=script&lang=js"
export * from "./extrato-formularios-declaracoes.vue?vue&type=script&lang=js"
import style0 from "./extrato-formularios-declaracoes.vue?vue&type=style&index=0&id=1a588da6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a588da6",
  null
  
)

export default component.exports